import { useMe } from "./useMe";

// Flag isAdmin servido por GET /api/me (misma allowlist que la policy "Admin"
// del backend). isLoading permite a los guards esperar la respuesta en vez de
// redirigir en falso durante la carga inicial.
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { data, isPending } = useMe();
  return { isAdmin: data?.isAdmin ?? false, isLoading: isPending };
}
